import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { BitfApiHelper } from '@common/libs/bitforce/core/services/api/bitf-api.helper';

import { environment } from '@env/environment';

import { IBitfApiResponse, IBitfApiRequest } from '@interfaces';
import { BitfFormItemConfig, FsStore } from '@models';
import { EBitfInterceptors } from '@enums';

@Injectable({
  providedIn: 'root',
})
export class FsService extends BitfApiService {
  constructor(public injector: Injector) {
    super('spdocs/document-archive', injector);
    // super('spdocs/document-archive', injector, environment.mockApiUrl, 'mockDbParser');
  }

  useFs(fs: FsStore): FsService {
    this.helper = new BitfApiHelper(`spdocs/${fs.configuration.spDoc}`, this.mockApiUrl, this.mockApiParser);
    return this;
  }

  getFormItemConfig(): Observable<IBitfApiResponse<BitfFormItemConfig>> {
    return super.request<BitfFormItemConfig>({
      path: '/form-items-config',
      method: 'GET',
      modelMapper: 'form-items-config',
    } as IBitfApiRequest);
  }

  download(apiRequest: IBitfApiRequest) {
    return this.fetch({
      ...apiRequest,
      method: 'GET',
      responseType: 'arraybuffer',
      relation: 'download',
      headers: [{ headerName: EBitfInterceptors.BITF_RETRY_INTERCEPTOR, value: 'skip' }],
    });
  }
}
